import ErrorOr from "shared/ErrorOr";
import defaultAxiosClient from "shared/service/api";
import { IntermediaryDto } from "./dtos/IntermediaryDto";
import { V360ReportDataDto } from "./dtos/V360ReportDataDto";
import { ReportConfigDto } from "./dtos/ReportConfigDto";
import { SalesPersonDto } from "./dtos/SalesPersonDto";
import { SearchResultsDto } from "./dtos/SearchResultsDto";
import FilterConfiguration from "view360Card/models/FilterConfiguration";

export interface IView360Service {
    searchEntities: (phrase: string, limit: number) => Promise<SearchResultsDto>;
    getItermediaryDetails: (id: number) => Promise<ErrorOr<IntermediaryDto>>;
    getSalesPersonDetails: (id: number) => Promise<ErrorOr<SalesPersonDto>>;
    getIntermediaryReportConfig: (id: number) => Promise<ErrorOr<ReportConfigDto>>;
    getSalesPersonReportConfig: (id: number) => Promise<ErrorOr<ReportConfigDto>>;
    loadReport: (filter: FilterConfiguration) => Promise<ErrorOr<V360ReportDataDto>>;
}

const unauthorized = "Nie masz odpowiednich uprawnień, aby zobaczyć te dane";

const view360Service: IView360Service = {
    searchEntities: async (phrase: string, limit: number) => {
        const phraseEncoded = encodeURI(phrase);
        const query = `/secured/v360/search?limit=${limit}&phrase=${phraseEncoded}`;

        const result = await defaultAxiosClient.get<SearchResultsDto>(query);
        return result.data;
    },

    getItermediaryDetails: async (id: number) => {
        try {
            const query = `/secured/v360/intermediary/${id}`;

            let result = await defaultAxiosClient.get<IntermediaryDto>(query);
            return ErrorOr.Success(result.data);
        } catch (error) {
            return ErrorOr.Failed(new Error(unauthorized));
        }
    },

    getSalesPersonDetails: async (id: number) => {
        try {
            const query = `/secured/v360/salesperson/${id}`;

            const result = await defaultAxiosClient.get<SalesPersonDto>(query);
            return ErrorOr.Success(result.data);
        } catch (error) {
            return ErrorOr.Failed(new Error(unauthorized));
        }
    },

    getIntermediaryReportConfig: async (id: number) => {
        try {
            const query = `/secured/v360/sales-report/intermediary/${id}/config`;

            const result = await defaultAxiosClient.get<ReportConfigDto>(query);
            return ErrorOr.Success(result.data);
        } catch (error) {
            return ErrorOr.Failed(new Error(unauthorized));
        }
    },

    getSalesPersonReportConfig: async (id: number) => {
        try {
            const query = `/secured/v360/sales-report/sales-person/${id}/config`;
            const result = await defaultAxiosClient.get<ReportConfigDto>(query);
            return ErrorOr.Success(result.data);
        } catch (error) {
            return ErrorOr.Failed(new Error(unauthorized));
        }
    },

    loadReport: async (filter: FilterConfiguration) => {
        try {
            const query = `/secured/v360/sales-report/${filter.getQueryPath()}`;
            const result = await defaultAxiosClient.get<V360ReportDataDto>(query);
            return ErrorOr.Success(result.data);
        } catch (error) {
            return ErrorOr.Failed(new Error(unauthorized));
        }
    },
};

export default view360Service;
